import { render } from "./HistoricIncidenceModal.vue?vue&type=template&id=12003c7c&scoped=true"
import script from "./HistoricIncidenceModal.vue?vue&type=script&lang=js"
export * from "./HistoricIncidenceModal.vue?vue&type=script&lang=js"

import "./HistoricIncidenceModal.vue?vue&type=style&index=0&id=12003c7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12003c7c"]])

export default __exports__